module.exports = __webpack_public_path__ + "img/quote.6712c4cc.svg";